import React, { useState, useContext, useEffect } from "react";
import ViewCaseInfo from "./case_views/caseinfo";
import ViewClaims from "./case_views/claims";
import ViewComments from "./case_views/comments";
import ViewDocuments from "./case_views/documents";
import ViewMotions from "./case_views/motions";
import ViewParties from "./case_views/parties";
import ViewPayments from "./case_views/payments";
import JisTabButton from "../controls/jisTabButton";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import CaseHeader from "./CaseHeader";
import ViewJudgement from "./case_views/judgement";

function CaseDetails({ caseId, data, initialtab = "caseinfo" }) {
  const { profile, token, setIsExpired } = useContext(ShareContext);
  const pagecode = "casedetails";
  const [page, setPage] = useState(null);
  const [tab, setTab] = useState(initialtab);
  const [caseData, setCaseData] = useState(data);
  const [isAction, setIsAction] = useState(false);
  console.log(data);
  // Check if user is Legal Counsel
  const isLegalCounsel = profile?.role?.name === "Legal Counsel";

  async function loadPage() {
    const _data = await Constants.onScreenDetails(pagecode, token);
    console.log(_data);
    setPage(_data);
  }
  useEffect(() => {
    // setActivePage({title:'Manage Role'});
    loadPage();
    //onLoad();
  }, []);

  useEffect(() => {
    if (data == null) {
      onLoad();
    } else {
      setCaseData(data);
    }

    setTab(initialtab);
  }, [caseId]);

  const onLoad = async () => {
    //for account registration
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/case-details/${caseId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();

      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setCaseData(data);
        if (data.legalcounsels.length > 0) {
          //try set the value of inAction
          var item = data.legalcounsels.find((r) => r.id == profile?.id);
          console.log(
            `*************************** ${item ? "found" : "not found"}`,
          );
          console.log(`item is hasRight ${data.hasRight}`);
          
        }
        setIsAction(data.hasRight);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return caseData == null ? (
    <div
      style={{
        background: "var(--primary)",
        padding: 16,
        color: "var(--background)",
      }}
    >
      <div className="spinner"></div> Loading case details..
    </div>
  ) : (
    <div>
      {/* <div>
        <div style={{ fontSize: "24px" }}>
          <span>Suit No: </span>
          <span>{caseData?.caseinfo?.caseNumber}</span>
        </div>
      </div> */}
      <CaseHeader caseId={caseData?.caseinfo?.caseNumber} />
      <div className="tab_body">
        <div
          className="tab_section"
          style={{ display: "flex", marginBottom: "20px" }}
        >
          <JisTabButton
            code="caseinfo"
            isActive={tab == "caseinfo"}
            title="Case Details"
            data={page}
            onClick={() => setTab("caseinfo")}
          />
          <JisTabButton
            code="caseclaims"
            isActive={tab == "caseclaims"}
            title="Claims"
            data={page}
            onClick={() => setTab("caseclaims")}
          />
          {!isLegalCounsel && (
            <JisTabButton
              code="casecomments"
              isActive={tab == "casecomments"}
              title="Comments"
              data={page}
              onClick={() => setTab("casecomments")}
            />
          )}
          <JisTabButton
            code="casedocuments"
            isActive={tab == "casedocuments"}
            title="Documents"
            data={page}
            onClick={() => setTab("casedocuments")}
          />
          <JisTabButton
            code="motions"
            isActive={tab == "motions"}
            title="Motions"
            data={page}
            onClick={() => setTab("motions")}
          />
          <JisTabButton
            code="parties"
            isActive={tab == "parties"}
            title="Parties"
            data={page}
            onClick={() => setTab("parties")}
          />
          <JisTabButton
            code="payments"
            isActive={tab == "payments"}
            title="Payments"
            data={page}
            onClick={() => setTab("payments")}
          />
          <JisTabButton
            code="case-judgement"
            isActive={tab == "case-judgement"}
            title="Judgement"
            data={page}
            onClick={() => setTab("case-judgement")}
          />
        </div>
        {tab == "caseinfo" && (
          <div className="tab_view">
            <ViewCaseInfo
              caseId={caseId}
              caseinfo={{
                ...caseData.caseinfo,
                claims: caseData.claims,
                fiats: caseData.fiats,
                causes: caseData.causes,
                parties: caseData.parties,
                assigneduser: caseData.assigneduser,
                deputysheriff: caseData.deputysheriff,
                legalcounsels: caseData.legalcounsels,
                presessions: caseData.presessions,
                mediations: caseData.mediations,
              }}
              isAction={isAction}
            />
          </div>
        )}

        {tab == "caseclaims" && (
          <div className="tab_view">
            <ViewClaims
              caseId={caseId}
              claims={caseData.claims}
              isAction={isAction } //&& !caseData.caseinfo.isConcluded
            />
          </div>
        )}

        {!isLegalCounsel && tab == "casecomments" && (
          <div className="tab_view">
            <ViewComments
              caseId={caseId}
              comments={caseData.comments}
              isAction={isAction && !caseData.caseinfo.isConcluded}
            />
          </div>
        )}

        {tab == "casedocuments" && (
          <div className="tab_view">
            <ViewDocuments
              caseId={caseId}
              documents={caseData.documents}
              filingtype={caseData.caseinfo.caseFilingId}
              isAction={isAction } //&& !caseData.caseinfo.isConcluded
            />
          </div>
        )}

        {tab == "motions" && (
          <div className="tab_view">
            <ViewMotions
              caseId={caseId}
              motions={caseData.motions}
              isAction={isAction}
            />
          </div>
        )}

        {tab == "parties" && (
          <div className="tab_view">
            <ViewParties
              caseId={caseId}
              parties={caseData.parties}
              isAction={isAction} // && !caseData.caseinfo.isConcluded
            />
          </div>
        )}

        {tab == "payments" && (
          <div className="tab_view">
            <ViewPayments
              caseId={caseId}
              payments={caseData.payments}
              isAction={isAction} // && !caseData.caseinfo.isConcluded
            />
          </div>
        )}

        {tab == "case-judgement" && (
          <div className="tab_view">
            <ViewJudgement
              caseId={caseId}
              caseinfo={caseData.caseinfo}
              parties={caseData.parties}
              claims={caseData.claims}
              motions={caseData.motions}
            />
          </div>
        )}
      </div>
      {/* Add your login form UI here */}
    </div>
  );
}

export default CaseDetails;
